import PropTypes from 'prop-types';
import React from 'react';
import overrideStyle from 'lib/overrideStyle';

import ChatWithAgentButton from './ChatWithAgentButton';

const Wrapper = overrideStyle('div')`
    align-items: center;
    background: #f9f9f9;
    border-top: 1px solid #d2d2d2;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    justify-content: center;
    padding: 25px;
`;

export default function ChatWithAgentSection({ colors }) {
  return (
    <Wrapper>
      Didn't answer your question?
      <ChatWithAgentButton colors={colors} />
    </Wrapper>
  );
}

ChatWithAgentSection.propTypes = {
  colors: PropTypes.object.isRequired,
};
